import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-upload.
* homepage: https://github.com/react-component/upload
*/
import React, { Component } from 'react';
import AjaxUpload from './AjaxUploader';
import IframeUpload from './IframeUploader';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";

function empty() {}

var propTypes = {
  component: PropTypes.string,
  style: PropTypes.object,
  clsPrefix: PropTypes.string,
  action: PropTypes.string,
  name: PropTypes.string,
  multipart: PropTypes.bool,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onProgress: PropTypes.func,
  onStart: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  headers: PropTypes.object,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  beforeUpload: PropTypes.func,
  customRequest: PropTypes.func,
  onReady: PropTypes.func,
  withCredentials: PropTypes.bool,
  supportServerRender: PropTypes.bool
};
var defaultProps = {
  component: 'span',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onProgress: empty,
  onReady: empty,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  supportServerRender: false,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false
};
var Upload = (_dec = WebUI({
  name: "upload",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Upload, _Component);

  var _super = _createSuper(Upload);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.call(this, props);
    _this.state = {
      Component: null
    };
    _this.getComponent = _this.getComponent.bind(_assertThisInitialized(_this));
    _this.abort = _this.abort.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Upload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.supportServerRender) {
        /* eslint react/no-did-mount-set-state:0 */
        this.setState({
          Component: this.getComponent()
        }, this.props.onReady);
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return typeof FormData !== 'undefined' ? AjaxUpload : IframeUpload;
    }
  }, {
    key: "abort",
    value: function abort(file) {
      this.inner.abort(file);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.supportServerRender) {
        var _Component2 = this.state.Component;

        if (_Component2) {
          return /*#__PURE__*/React.createElement(_Component2, _extends({}, omit(this.props, ["preventDefaultPreview", "enterDragger", "leaveDragger", "mergeFiles", "removeText", "downloadText"]), {
            ref: function ref(el) {
              return _this2.inner = el;
            }
          }));
        }

        return null;
      }

      var Component = this.getComponent();
      return /*#__PURE__*/React.createElement(Component, _extends({}, omit(this.props, ["preventDefaultPreview", "enterDragger", "leaveDragger", "mergeFiles", "removeText", "downloadText"]), {
        ref: function ref(el) {
          return _this2.inner = el;
        }
      }));
    }
  }]);

  return Upload;
}(Component)) || _class);
;
Upload.propTypes = propTypes;
export default Upload;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/Upload.js